import { g as getLocale, t as trackMessageCall, l as localizeHref } from "./runtime.js";
import { O as spread_attributes, D as pop, A as push } from "./index2.js";
const en_sign_in_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Remember Links`;
  }
);
const de_sign_in_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Links merken`;
  }
);
const sp_sign_in_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Recordar enlaces`;
  }
);
const sign_in_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("sign_in_link", locale);
  if (locale === "en") return en_sign_in_link();
  if (locale === "de") return de_sign_in_link();
  return sp_sign_in_link();
};
const en_sign_out = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Sign out`;
  }
);
const de_sign_out = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Abmelden`;
  }
);
const sp_sign_out = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Cerrar sesión`;
  }
);
const sign_out = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("sign_out", locale);
  if (locale === "en") return en_sign_out();
  if (locale === "de") return de_sign_out();
  return sp_sign_out();
};
function AnchorButton($$payload, $$props) {
  push();
  const {
    children,
    transparent = false,
    href,
    download,
    $$slots,
    $$events,
    ...props
  } = $$props;
  $$payload.out.push(`<a${spread_attributes(
    {
      href: download ? href : localizeHref(href),
      ...props,
      download
    },
    "svelte-7936pn",
    { button: true, transparent }
  )}>`);
  children($$payload);
  $$payload.out.push(`<!----></a>`);
  pop();
}
export {
  AnchorButton as A,
  sign_out as a,
  sign_in_link as s
};
